import store from '@/store'
import TutorRouter from '@/components/pages/tutor/index.vue';
import TutorList from '@/components/pages/tutor/Tutors.vue';
import TutorDetail from '@/components/pages/tutor/profile/TutorDetail.vue';
import TutorAdd from '@/components/pages/tutor/profile/TutorAdd.vue';
import TutorAddConfirm from '@/components/pages/tutor/profile/TutorAddConfirm.vue';
import TutorEdit from '@/components/pages/tutor/profile/TutorEdit.vue';
import TutorEditConfirm from '@/components/pages/tutor/profile/TutorEditConfirm.vue';
import TutorEditTraffic from '@/components/pages/tutor/TutorEditTraffic.vue';
import TutorConfirmTraffic from '@/components/pages/tutor/TutorConfirmTraffic.vue';
import TutorBulkUpdate from '@/components/pages/tutor/TutorBulkUpdate.vue';
import TutorLessonSchedule from '@/components/pages/tutor/TutorLessonSchedule.vue';
import tutorSendMails from '@/components/pages/tutor/TutorSendMails.vue';
import Contract from '@/components/pages/tutor/contract/Detail.vue'

/**
 * チューターの場合、自身のプロフィールを参照しているか確認
 * @param {string} tutorId 確認するチューターのID
 * @returns {boolean} true: 自身のプロフィール（もしくはチューター以外）, false: 自身以外のプロフィール
 */
const isSelfProfileOnTutor = (tutorId) => {
  if (store.state.auth?.profile?.authority !== 'tutor') {
    // 権限がtutor以外の場合OK
    return true
  }
  if (tutorId === store.state.auth?.profile?.id) {
    // 権限がtutorかつ自身の場合はOK
    return true
  }
  return false
}

export default {
  path: '/tutors',
  name: 'TutorsRouter',
  component: TutorRouter,
  children: [
    {
      path: '/tutors',
      component: TutorList,
      name: 'TutorList',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/:tutorId/lessonSchedule',
      component: TutorLessonSchedule,
      name: 'TutorLessonSchedule',
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
    },
    {
      path: '/tutors/:id',
      component: TutorDetail,
      name: 'TutorDetail',
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
      beforeEnter: ((to, from, next) => {
        if (isSelfProfileOnTutor(to?.params?.id)) {
          next()
        } else {
          // 自身以外のプロフィールを参照しようとしていた場合、ホームに戻る
          next({ name: 'Home' })
        }
      }),
    },
    {
      path: '/tutors/:tutorId/contracts/:contractId',
      component: Contract,
      name: 'TutorContract',
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
      beforeEnter: ((to, from, next) => {
        if (isSelfProfileOnTutor(to?.params?.tutorId)) {
          next()
        } else {
          // 自身以外のプロフィールを参照しようとした場合、ホームに戻る
          next({ name: 'Home' })
        }
      }),
    },
    {
      path: '/tutors/:id/edit',
      component: TutorEdit,
      name: 'TutorEdit',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/:id/edit/confirm',
      component: TutorEditConfirm,
      name: 'TutorEditConfirm',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/add',
      component: TutorAdd,
      name: 'TutorAdd',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/add/confirm',
      component: TutorAddConfirm,
      name: 'TutorAddConfirm',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/:id/traffic/edit',
      component: TutorEditTraffic,
      name: 'TutorEditTraffic',
      acceptRoles: ['senior', 'admin'],
    },
    {
      path: '/tutors/:id/traffic/confirm',
      component: TutorConfirmTraffic,
      name: 'TutorConfirmTraffic',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/bulkUpdate',
      component: TutorBulkUpdate,
      name: 'BulkUpdate',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/sendMails',
      component: tutorSendMails,
      name: 'tutorSendMails',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
  ],
}
